import * as React from 'react';
import styled from 'styled-components';
import 'src/ReactTableStyles.css';
import 'react-table/react-table.css';
import { Document, Pdf, Page } from 'react-pdf';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { FlexPosition, Color } from 'src/components/Globals/Globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'src/components/Button/Button';

const PdfWrapper = styled(Flex)`
  width: 100%;
`;

const StyledPage = styled(Page)`
  display: flex;
  height: 100%;
  & canvas {
    margin: auto;
    height: auto !important;
    width: auto !important;
    max-height: 100%;
    max-width: 100%;
    border: 2px ${Color.lightGrey} solid;
  }
  & .react-pdf__Page__annotations {
    display: none;
  }
`;

const StyledDocument = styled(Document)`
  overflow: hidden;
  height: 70vh;
  width: 100%;
`;

const PageSwitcher = styled(Flex)`
  width: 100%;
`;

const PageSwitcherInput = styled.input`
  background: none;
  width: 3em;
  margin-right: 0.5em;
  padding-left: 5px;
  padding-right: 5px;
`;

const PageSwitcherButton = styled(Button)`
  background: none;
  border: none;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

interface IPdfPreviewProps {
  src: string;
}

interface IPdfPreviewState {
  numPages?: number;
  pageNumber: number;
}

export class PdfPreview extends React.Component<IPdfPreviewProps, IPdfPreviewState> {
  private pageNumnberInput: number = 1;
  constructor(props: IPdfPreviewProps) {
    super(props);

    this.state = {
      pageNumber: 1
    };
  }

  public onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ pageNumber: this.pageNumnberInput });
  };

  public changePage(page: number) {
    const pageSwitcherInput: any = document.getElementById('pageSwitcher');
    if (pageSwitcherInput) {
      pageSwitcherInput.value = page.toString();
    }
    this.setState({ pageNumber: page });
  }

  public render() {
    return (
      <PdfWrapper
        direction={FlexDirection.column}
        alignHorizontal={FlexPosition.center}
        alignVertical={FlexPosition.center}
      >
        {this.props.src && (
          <StyledDocument
            file={this.props.src}
            onLoadSuccess={(pdf: Pdf) => this.setState({ numPages: pdf.numPages })}
          >
            <StyledPage pageNumber={this.state.pageNumber} />
          </StyledDocument>
        )}
        {this.props.src && (
          <PageSwitcher alignHorizontal={FlexPosition.evenly}>
            <PageSwitcherButton
              disabled={this.state.pageNumber === 1}
              onClick={() => this.changePage(this.state.pageNumber - 1)}
            >
              <FontAwesomeIcon icon="arrow-left" />
              <span>&nbsp; Previous page</span>
            </PageSwitcherButton>
            <form
              style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}
              onSubmit={e => this.onSubmit(e)}
            >
              <Flex
                flexSize={1}
                alignHorizontal={FlexPosition.center}
                alignVertical={FlexPosition.center}
              >
                <PageSwitcherInput
                  id="pageSwitcher"
                  type="number"
                  onChange={e => (this.pageNumnberInput = parseInt(e.currentTarget.value, 10))}
                />
                of {this.state.numPages}
              </Flex>
            </form>
            <PageSwitcherButton
              disabled={this.state.pageNumber === this.state.numPages}
              onClick={() => this.changePage(this.state.pageNumber + 1)}
            >
              <span>Next page &nbsp;</span>
              <FontAwesomeIcon icon="arrow-right" />
            </PageSwitcherButton>
          </PageSwitcher>
        )}
      </PdfWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilePreview/PdfPreview.tsx